import { Box, Typography } from '@mui/material';
import { Button } from '@coolblue-development/freddy';
import CatoLogo from './CatoContainer/Header/CatoLogo';

// Same words and recovery as Solvie's pane fallback. Reload the whole page rather than
// remount: Amazon Connect Streams keeps global state that a remount can't reset.
function Error(): JSX.Element {
  return (
    <Box sx={{ position: 'absolute', width: '100%', top: '50%', transform: 'translateY(-50%)', textAlign: 'center' }}>
      <Box>
        <CatoLogo />
      </Box>
      <Box>
        <Typography variant="h1" component="div" sx={{ marginBottom: 2 }}>
          Something went wrong here.
        </Typography>
        <Button variant="primary" onClick={() => window.location.reload()}>
          Reload
        </Button>
      </Box>
    </Box>
  );
}

export default Error;
